/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentModel, ComponentData, ComponentFieldKey } from '../model/component.model';
import { Alignment } from '../model/alignment.model';
import { ViewComponentKey } from '../key/view-component.key';

export interface TableColumnData extends ComponentData {
  index: number;
  format?: string;
  alignment?: Alignment;
}

export class TableColumnFieldKey {
  static readonly INDEX = 'index';
  static readonly FORMAT = 'format';
  static readonly ALIGNMENT = 'alignment';
}

export class TableColumnModel extends ComponentModel implements TableColumnData {
  static readonly KEYS = ComponentModel.KEYS.concat(
    Object.keys(TableColumnFieldKey).map((key) => TableColumnFieldKey[key])
  );

  constructor(data?: TableColumnData, keys?: string[]) {
    super(data, keys || TableColumnModel.KEYS);
  }

  get index(): number {
    return this.get(TableColumnFieldKey.INDEX);
  }

  get format(): string {
    return this.get(TableColumnFieldKey.FORMAT);
  }

  set format(value: string) {
    this.set(TableColumnFieldKey.FORMAT, value);
  }

  get alignment(): Alignment {
    return this.get(TableColumnFieldKey.ALIGNMENT);
  }

  set alignment(value: Alignment) {
    this.set(TableColumnFieldKey.ALIGNMENT, value);
  }

  protected setupValues(values: TableColumnData, exclusive: boolean): TableColumnData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.TABLE_COLUMN;
    }
    return super.setupValues(values, exclusive) as TableColumnData;
  }
}
